import {Dialog, withMobileDialog, withStyles} from '@material-ui/core'
const LoginModalStyles = {
    title: {
        textAlign: 'center',
        padding: '0em'
    },

    content: {
        display: 'flex',
        flex: '0 0 auto',
        flexDirection: 'column',
        transitionDuration: '1s'
    },

    actionButtons: {
        justifyContent: 'center',
        margin: '0em'
    },

    errorMessage: {
        textAlign: 'center'
    }
}

export const LoginStyledDialog = withMobileDialog()(withStyles({
    paper: {
        alignSelf: 'flex-start',
        padding: '3em',
        marginTop: '5em'
    },
    paperFullScreen: {
        padding: '3em',
        paddingTop: '5em',
        marginTop: '1em'
    }
})(Dialog))

export default LoginModalStyles
